import { Component } from 'react';
import { connect } from 'react-redux';
import CarouselItem from './carousel-item';
import CarouselRender from './carousel-render';

import './style.css';

class TradeCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isScrolled: false,
      data: []
    };
  }

  renderItems = () => {
    const { isScrolled } = this.state;

    this.setState({
      data: this.props.tradeArticles.map((article, index) => (
        <CarouselItem
          key={index}
          image={article.attributes.link.image}
          id={article.id}
          name={article.attributes.title}
          isScrolled={isScrolled}
        />
      ))
    });
  }

  componentDidUpdate = (prevProps) => {
    const { tradeArticles } = this.props;

    if (prevProps.tradeArticles !== tradeArticles && Array.isArray(tradeArticles) && !!tradeArticles.length) {
      this.renderItems();
    }
  }

  componentDidMount = () => {
    this.renderItems();
  }

  handleOnClick = () => {
    const { isScrolled } = this.state;

    this.setState({ isScrolled: !isScrolled }, () => {
      this.renderItems();
    });
  }

  render() {
    const { loading } = this.props;
    const { data } = this.state;

    return (
      <CarouselRender
        loading={loading}
        data={data}
        title='Trade news'
        onClick={this.handleOnClick}
      />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.latestNews.fetching,
  tradeArticles: state.latestNews.latestNews.filter(article =>
    article.attributes.category.name === 'TRADE NEWS')
});

export default connect(mapStateToProps)(TradeCarousel);
